/**
 * Expects a string as input and returns a boolean
 * @param {string} inputValue
 * @returns {Boolean}
 */
export const validateInput = (inputValue) => {
  if (typeof inputValue !== 'string') {
    return false;
  }

  const cleanValue = inputValue.trim();
  const hasValidCharacters = /^(\d|\w|\s|-|')*$/.test(inputValue);
  return !!cleanValue && cleanValue.length <= 50 && cleanValue.length > 0 && hasValidCharacters;
};
